import { render, staticRenderFns } from "./timeHeader.vue?vue&type=template&id=31da8e04&scoped=true"
import script from "./timeHeader.vue?vue&type=script&lang=js"
export * from "./timeHeader.vue?vue&type=script&lang=js"
import style0 from "./timeHeader.vue?vue&type=style&index=0&id=31da8e04&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31da8e04",
  null
  
)

export default component.exports